<template>
  <div>
    <div :id="panelID" class="up_panel" v-touch:swipe.left="leftSlide" v-touch:swipe.right="rightSlide">
      <el-carousel  :class="isMobile() === true ? 'carousel_mobile' : 'carousel'"
        :id="carouselID"
        ref="carousel"
        trigger="click"
        :autoplay="false"
        :loop="false"
        indicator-position="none"
        :height="screenHeight"
        @change="carouselChange"
      >
        <el-carousel-item v-for="pic in pics" :key="pic.url">
            <img :src="pic.url">
            <p v-html='pic.text'></p>
            <span style="color: #579DFF;">{{carouselIndex + 1}}</span>/<span>{{arrayLength}}</span>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="down_panel">
      <div :class="isMobile() === true ? 'div_mobile' : 'div_pc'">
        <img v-for="(pic, index) in pics" :key="pic.url" :index="index"
          :src="pic.url" :id="'img'+index" @click="onclick">
      </div>
    </div>
  </div>
</template>

<script>
import { uIsMobile } from '../libs/utils.js'

export default {
  props: {
    picsdata: Array
  },
  data () {
    return {
      pics: [],
      isMobile: uIsMobile,
      carouselIndex: 0,
      arrayLength: this.picsdata.length,
      screenHeight: '450px',
      currtenHL: 0,
      panelID: 'panelID',
      carouselID: 'carouselID'
    }
  },
  mounted () {
    this.pics = this.picsdata
    this.setSize()
    window.addEventListener('resize', this.setSize)
  },
  updated () {
    // console.log('updated')
    const compon = document.getElementById('img' + this.carouselIndex)
    compon.setAttribute('style', 'border: solid #579DFF')
    this.currtenHL = this.carouselIndex
  },
  methods: {
    leftSlide () {
      this.onNext()
    },
    rightSlide () {
      this.onPre()
    },
    setSize () {
      const div = document.getElementById(this.panelID)
      console.log(div.clientHeight)
      this.screenHeight = (div.clientHeight - 3) + 'px'
    },
    onclick (e) {
      const id = e.srcElement.id
      if (this.currtenHL !== parseInt(id[3])) {
        const elem = document.getElementById('img' + this.currtenHL)
        elem.setAttribute('style', 'solid rgb(228, 221, 221)')

        const elem1 = document.getElementById(id)
        elem1.setAttribute('style', 'border: solid #579DFF')

        this.currtenHL = parseInt(id[3])
        const diff = this.currtenHL - this.carouselIndex
        // console.log('diff : ' + diff)
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            this.onNext()
          }
        } else {
          for (let i = 0; i > diff; i--) {
            this.onPre()
          }
        }
        this.carouselChange(this.currtenHL)
      }
    },
    carouselChange (index) {
      console.log('carouselChange : ' + index)
      this.carouselIndex = index
      if (index !== this.currtenHL) {
        const elem = document.getElementById('img' + this.currtenHL)
        elem.setAttribute('style', 'solid rgb(228, 221, 221)')

        const elem1 = document.getElementById('img' + this.carouselIndex)
        elem1.setAttribute('style', 'border: solid #579DFF')

        this.currtenHL = this.carouselIndex
      }
    },
    onNext () {
      this.$refs.carousel.next()
      console.log('next')
    },
    onPre () {
      this.$refs.carousel.prev()
      console.log('previous')
    }
  },
  metaInfo () {
    return {
      title: 'Lenovo One用户手册',
      name: 'viewport',
      content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'
    }
  }
}
</script>

<style scoped>
.float_left{
  float: left;
}
.up_panel{
  position: absolute;
  top: 0%;
  right: 0%;
  width: 100%;
  height: 84%;
  display: flex;
  justify-content: center;
  background-color: #F5F9FB;
}
.up_panel .carousel{
  width: 50%;
  height: 100%;
  font-family: 'Microsoft YaHei',Helvetica;
}
.up_panel .carousel_mobile{
  width: 80%;
  height: 100%;
  font-family: 'Microsoft YaHei',Helvetica;
}
.up_panel .carousel img{
  margin-top: 7%;
  height: 70%;
  max-height: 100%;
  max-width: 100%;
  box-shadow:rgba(0, 0, 0, 0.201) 0px 0px 10px;
  border-radius: 10px;
}

.up_panel .carousel p{
  margin-top: 4%
}
.up_panel .carousel .span{
}
.up_panel .carousel_mobile img{
  margin-top: 15%;
  height: 70%;
  max-height: 100%;
  max-width: 100%;
  box-shadow:rgba(0, 0, 0, 0.315) 0px 0px 15px;
  border-radius: 10px;
}
.down_panel{
  position: absolute;
  display: flex;
  justify-content: center;
  top: 84%;
  right: 0%;
  width: 100%;
  height: 16%;
  background-color: #e5e5e5;
  overflow: hidden;
}
.down_panel .div_pc{
  display: flex;
  justify-content: center;
  height: 75%;
  width: 65%;
  margin-top: 1%;
  margin-bottom: 3%;
}
.down_panel .div_mobile{
  display: flex;
  justify-content: center;
  height: 75%;
  width: 65%;
  margin-top: 3%;
  margin-bottom: 3%;
}
.down_panel img{
  margin: auto 1%;
  border-image-width: 2px;
  max-width: 100%;
  max-height: 100%;
  border-radius: 5px;
  cursor: pointer;
}
</style>
